import TwoColFullScreenLayout from '@layouts/v2/twocolfullscreen.layout';
import ButtonV2, {
  ButtonV2Rounded,
  ButtonV2Size,
  ButtonV2Style,
} from '@ui-kit/v2/Button';
import { CheckBoxWithLabel } from '@ui-kit/v2/CheckboxV2';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import useTranslation from 'src/i18n/useTranslation';

const TermAndCon = (props) => {
  const { handleSubmit } = props;
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [isCheckable, setIsCheckable] = useState<boolean>(false);
  const scrollableRef = useRef(null);
  const { t } = useTranslation();

  const onScroll = () => {
    if (scrollableRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = scrollableRef.current;
      const isNearBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;

      setIsCheckable(isNearBottom);
    }
  };

  useEffect(() => {
    const scrollableElement = scrollableRef.current;

    if (scrollableElement) {
      scrollableElement.addEventListener('scroll', onScroll);

      // Clean-up
      return () => {
        scrollableElement.removeEventListener('scroll', onScroll);
      };
    }
  }, [scrollableRef]);

  return (
    <TwoColFullScreenLayout
      leftContent={
        <div>
          <h3 className="mb-4 text-h3 font-bold">
            {t('termandconPage.title')}
          </h3>
          <p className="mb-6 text-heading font-semibold">
            {t('termandconPage.subtitle')}
          </p>
          <ButtonV2
            variantClassName={classNames(
              ButtonV2Rounded.large,
              ButtonV2Style.primary,
              ButtonV2Size.small,
              'w-1/3 h-fit',
            )}
            buttonProps={{
              disabled: !isChecked,
              onClick: () => handleSubmit(),
            }}
          >
            {t('continue')}
          </ButtonV2>
        </div>
      }
      mobileHeader={
        <div className="pb-4 pl-6 pt-12 text-heading font-bold">
          {t('termandconPage.heading')}
        </div>
      }
    >
      <div
        className="relative h-full min-h-0 overflow-auto px-6 pb-26 pt-6 lg:pb-40 lg:pl-15 lg:pr-20 lg:pt-24.5"
        ref={scrollableRef}
      >
        <div className="flex flex-col gap-y-4">
          {new Array(14).fill({}).map((_, idx) => (
            <div className="text-grayv2-700" key={`terms_${idx}`}>
              <p className="mb-2 text-subheadingv2 font-semibold">
                {t(`termandconPage.ruleTitle_${idx}`)}
              </p>
              <p className="whitespace-pre-line text-p1 font-regular">
                {t(`termandconPage.ruleDescription_${idx}`)}
              </p>
            </div>
          ))}
        </div>
        <div className="fixed bottom-0 left-0 right-0 px-6 pb-8 pt-4 lg:static lg:pl-0">
          <CheckBoxWithLabel
            labelProps={{ title: t('termandconPage.agree') }}
            checkboxV2Props={{
              isChecked,
              onChange: () => setIsChecked((prev) => !prev),
            }}
            disabled={!isCheckable}
          />
          <ButtonV2
            variantClassName={classNames(
              ButtonV2Rounded.large,
              ButtonV2Style.primary,
              ButtonV2Size.small,
              'lg:hidden w-full h-fit mt-2.5',
            )}
            buttonProps={{
              disabled: !isChecked || !isCheckable,
              onClick: () => handleSubmit(),
            }}
          >
            {t('continue')}
          </ButtonV2>
        </div>
      </div>
    </TwoColFullScreenLayout>
  );
};

export default TermAndCon;
